import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { DesignSystemModule } from '@peca/design-system';
import { KanbanLoadSkeletonCardComponent } from '../kanban-load-card-skeleton/kanban-load-card-skeleton.component';

@Component({
  selector: 'peca-kanban-column',
  imports: [CommonModule, DesignSystemModule, KanbanLoadSkeletonCardComponent],
  templateUrl: './kanban-column.component.html',
  styleUrl: './kanban-column.component.scss',
})
export class KanbanColumnComponent {
  height = input<number>();
  indicator = input(0);
  title = input('');
  cardsLoading = input(false);
  cardsFailed = input(false);
  isEmpty = input(false);
  emptyMessage = input<string>('Nenhum item encontrado');
  loadingNCards = input<number>(3);

  retry = output<void>();

  get skeletonArray() {
    return Array(10).fill(0);
  }
}
